import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar-premium ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={scrollToTop}>
          {/* FIXED: Pointing to ww.png as per your file list */}
          <img 
            src="/images/ww.png" 
            alt="Sunraf Logo" 
            className="logo-shield" 
          />
          <div className="logo-text">
            <span className="brand-name">Sunraf</span>
            <span className="brand-sub">InfoTech</span>
          </div>
        </Link>
        
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={scrollToTop}>Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`} onClick={scrollToTop}>Services</Link>
          </li>
          <li className="nav-item">
            <Link to="/industries" className={`nav-link ${location.pathname === '/industries' ? 'active' : ''}`} onClick={scrollToTop}>Industries</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-cta-btn" onClick={scrollToTop}>Request a Private Demo</Link>
          </li>
        </ul>
        
        <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span><span></span><span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;